import { Component } from '@angular/core';

@Component({
  selector: 'app-edital',
  templateUrl: './edital.component.html',
  styleUrls: ['./edital.component.scss'],
})
export class EditalComponent {}
